import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IBaggageAllowance,
  IDepartureTime,
  IFilters,
  IMaxDurations,
  IPreferredAirlines,
  IStops,
  ITravellerTypes,
} from ".";
import { initialFiltersState } from "./initialState";

export const filtersSlice = createSlice({
  name: "filter",
  initialState: initialFiltersState,
  reducers: {
    changeBaggageAllowance: (
      state,
      action: PayloadAction<IBaggageAllowance>,
    ) => {
      state.baggageAllowance = action.payload;
    },
    changeTravellerTypes: (state, action: PayloadAction<ITravellerTypes>) => {
      state.travellerTypes = action.payload;
    },
    changeStops: (state, action: PayloadAction<IStops>) => {
      state.stops = action.payload;
    },
    changeDepartureTime: (state, action: PayloadAction<IDepartureTime>) => {
      state.departureTime = action.payload;
    },
    changeMaxDurations: (state, action: PayloadAction<IMaxDurations>) => {
      state.maxDurations = action.payload;
    },
    changePreferredAirlines: (
      state,
      action: PayloadAction<IPreferredAirlines>,
    ) => {
      state.preferredAirlines = action.payload;
    },
    changeAllAirlines: (state, action: PayloadAction<string[]>) => {
      state.allAirlines = action.payload;
    },
    setEntireFilters: (state, action: PayloadAction<IFilters>) => {
      return action.payload;
    },
  },
});
export const {
  changeBaggageAllowance,
  changeTravellerTypes,
  changeStops,
  changeDepartureTime,
  changeMaxDurations,
  changePreferredAirlines,
  changeAllAirlines,
  setEntireFilters,
} = filtersSlice.actions;
